class HTTP_STATUS_CODE {
    static get OK() {
        return 200;
    }

    static get BAD_REQUEST() {
        return 400;
    }

    static get UNAUTHORISED() {
        return 401;
    }

    static get NOT_AUTH() {
        return 403;
    }

    static get INTERNAL_SERVER_ERROR() {
        return 500;
    }
}

class HTTP_STATUS_MESSAGE {
    static get OK() {
        return 'Success';
    }

    static get BAD_REQUEST() {
        return 'Bad Request';
    }

    static get UNAUTHORISED() {
        return 'Unauthorized';
    }

    static get NOT_AUTH() {
        return 'Not Auth';
    }

    static get INTERNAL_SERVER_ERROR() {
        return 'Something went wrong';
    }
}

Object.freeze(HTTP_STATUS_CODE);

export { HTTP_STATUS_CODE, HTTP_STATUS_MESSAGE };
